import { Controller } from "@hotwired/stimulus"

// Reveals and plays the promotional video (S3 mp4) when the cover's play button is clicked,
// and stops it when the modal is closed.
export default class extends Controller {
  static targets = ["cover"]
  static values = { src: String }

  connect() {
    this.stopVideo = this.stopVideo.bind(this)
    this.modal = this.element.closest(".modal")
    if (this.modal) $(this.modal).on("hidden.bs.modal", this.stopVideo)
  }

  disconnect() {
    if (this.modal) $(this.modal).off("hidden.bs.modal", this.stopVideo)
  }

  play() {
    const { clientWidth, clientHeight } = this.coverTarget

    this.video = document.createElement("video")
    this.video.src = this.srcValue
    this.video.controls = true
    this.video.autoplay = true
    this.video.className = "d-block w-100 rounded"
    // Reserve the cover's box up front so the empty player doesn't flash/resize before metadata loads.
    if (clientWidth && clientHeight) this.video.style.aspectRatio = `${clientWidth} / ${clientHeight}`

    this.coverTarget.replaceWith(this.video)
    this.video.play()
  }

  stopVideo() {
    if (!this.video) return

    this.video.pause()
    this.video.currentTime = 0
  }
}
